/* eslint-disable react-hooks/exhaustive-deps */
import {
  ArrowRightOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import {
  Button,
  Divider,
  Drawer,
  Empty,
  Form,
  message,
  Modal,
  Table,
  Tag,
} from 'antd'
import 'antd/dist/antd.css'
import * as dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { ALL_COUNTRIES, FREE_SHIPPING_RATES } from '../../consts'
import { ErpClientContext } from '../../services/erp'
import { CreateFreeShippingRatesForm } from './createFreeShippingRatesForm'

export function FreeShippingRatesPage() {
  const erpService = useContext(ErpClientContext)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(undefined)
  const [drawer, showDrawer] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    fetchFreeShippingRates()
  }, [])

  const fetchFreeShippingRates = async () => {
    setLoading(true)
    const response = await erpService.getFreeShippingRates()
    if (response.status === 200) {
      const data = await response.json()
      setData(data)
    } else {
      const error = await response.text()
      message.error(`Failed getting data: ${error}.`, 5)
    }
    setLoading(false)
  }

  const renderCountry = (pais) => ALL_COUNTRIES[pais]

  const renderShippingRate = (tarifa) => FREE_SHIPPING_RATES[tarifa]

  const renderDates = (record) => {
    const colors = {
      expired: ['#bbb', '#bbb'],
      current: ['#2db7f5', '#108ee9'],
    }
    const status = dayjs(record.hasta) < new Date() ? 'expired' : 'current'
    const renderDate = (val) => dayjs(val).format('DD/MM/YYYY HH:mm')

    return (
      <>
        <Tag color={colors[status][0]}>{renderDate(record.desde)}</Tag>
        <ArrowRightOutlined />
        &nbsp;
        <Tag color={colors[status][1]}>{renderDate(record.hasta)}</Tag>
      </>
    )
  }

  const renderRowActions = (text, record, index) => {
    return <DeleteRecord record={record} />
  }

  const DeleteRecord = ({ record }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const showModal = () => {
      setIsModalOpen(true)
    }

    const handleCancel = () => {
      setIsModalOpen(false)
    }

    const handleOk = async () => {
      const response = await erpService.deleteFreeShippingRate(record.id)

      if (response.status === 200) {
        message.success(`Deleted shipping rate #${record.id} `, 2.5)
        fetchFreeShippingRates()
      } else {
        const error = await response.text()
        message.error(`Failed deleting row: ${error}`, 5)
      }

      setIsModalOpen(false)
    }

    return (
      <>
        <Button
          size="small"
          icon={<DeleteOutlined />}
          danger
          onClick={showModal}
        >
          Delete
        </Button>

        <Modal
          title={`Delete record #${record.id}`}
          visible={isModalOpen}
          onCancel={handleCancel}
          onOk={handleOk}
        >
          <p>{`Are you sure you want to delete the record #${record.id}?`}</p>
        </Modal>
      </>
    )
  }

  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Dates',
      key: 'desde',
      render: renderDates,
    },
    {
      title: 'Country',
      dataIndex: 'pais',
      render: renderCountry,
    },
    {
      title: 'Shipping tariff type',
      dataIndex: 'tarifa',
      render: renderShippingRate,
    },
    {
      title: 'Minimum sum of products',
      dataIndex: 'cart_amount',
    },
    {
      title: 'Minimum product price',
      dataIndex: 'min_precio_uni',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: renderRowActions,
    },
  ]

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <div className="level-left">
        <h2 className="title is-size-5">Free Shipping Rates</h2>
      </div>

      <Divider />

      <Drawer
        title="Add a new free shipping rate"
        width={600}
        onClose={() => showDrawer(false)}
        visible={drawer}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <CreateFreeShippingRatesForm
          key={`free-shipping-rates-form-${drawer}`}
          onClose={() => showDrawer(false)}
          onCreateFreeShippingRates={fetchFreeShippingRates}
        />
      </Drawer>

      <Form layout={'inline'} form={form}>
        <Form.Item>
          <Button
            type="primary"
            onClick={() => showDrawer(true)}
            icon={<PlusOutlined />}
          >
            Add Shipping Rate
          </Button>
        </Form.Item>
      </Form>

      <Divider />

      {loading && <p>Loading...</p>}
      {!loading && !data && <Empty />}
      {!loading && data && (
        <Table
          bordered
          columns={tableColumns}
          dataSource={data.result}
          pagination={{
            pageSize: data.per_page,
            position: ['topLeft', 'bottomRight'],
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} records`,
            total: data.result.length,
          }}
          rowKey={(record) => record.id}
          size="small"
        />
      )}
    </div>
  )
}
